import React from 'react';
import PropTypes from 'prop-types';

/**
 * Reusable icon button component
 */
const IconButton = ({ 
  icon, 
  onClick, 
  variant = 'default',
  className = '',
  ...props 
}) => {
  const baseClasses = "p-1.5 rounded-full shadow-sm transition-all";
  const variantClasses = {
    default: "bg-white hover:shadow-md hover:bg-gray-50 text-gray-600",
    danger: "bg-white hover:shadow-md hover:bg-red-50 text-gray-600 hover:text-red-600",
    primary: "bg-white hover:shadow-md hover:bg-purple-50 text-gray-600 hover:text-purple-600"
  };

  return (
    <button
      onClick={onClick}
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      {...props}
    >
      {icon}
    </button>
  );
};

IconButton.propTypes = {
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['default', 'danger', 'primary']),
  className: PropTypes.string
};

export default IconButton;
